import React, { FC }              from 'react';
import { RouteComponentProps }    from 'react-router-dom';
import styled                     from 'styled-components';
import { EBiddersPage }           from '@enums/registeredBidders';
import { BiddersListContainer }   from '@modules/registeredBidders/containers/BiddersListContainer';
import { BidderDetailsContainer } from '@modules/registeredBidders/containers/BidderDetailsContainer';

const Wrapper = styled.div`
  padding: 20px 100px;
`;

interface IParams {
  id?  : string;
  page : EBiddersPage;
}

export const RegisteredBiddersContainer: FC<RouteComponentProps<IParams>> = ({
  history : { push },
  match   : {
    params: {
      id,
      page = EBiddersPage.Search,
    },
  },
}) => (
  <Wrapper>
    {page === EBiddersPage.Search && <BiddersListContainer />}

    {page === EBiddersPage.Details && id && (
      <BidderDetailsContainer
        id   = {id}
        push = {push}
      />
    )}
  </Wrapper>
);
